(function () {
  function reveal(el) {
    el.classList.add('is-revealed');
    el.addEventListener('animationend', function clear() {
      el.style.willChange = 'auto';
      el.removeEventListener('animationend', clear);
    });
  }

  if (typeof IntersectionObserver === 'undefined') {
    document.querySelectorAll('.evol-reveal').forEach(reveal);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px 0px 0px', threshold: 0.01 });

  function arm() {
    document.querySelectorAll('.evol-reveal:not(.is-revealed)').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      // If element is already visible at page load (above fold or in viewport),
      // reveal it immediately so it doesn't stay hidden waiting for scroll.
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        reveal(el);
        return;
      }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();
